import { formatDuration } from "../echoflicks/journey/format";

export const label = (value: string) => value.replaceAll("_", " ");
export const duration = (milliseconds?: number | null) =>
  formatDuration(milliseconds) ?? "Unavailable";
export const timestamp = (value?: string | null) =>
  value
    ? new Date(value).toLocaleString(undefined, { timeZoneName: "short" })
    : "Unknown";
export const elapsed = (start: string | null | undefined, end: string) =>
  start ? duration(Date.parse(end) - Date.parse(start)) : "Unknown";
